import { requireAuth } from './authHelper'

const routes = [
  {
    path: '/curriculums',
    component: require('@/pages/InAppWeb/Curriculums').default,
  },
  {
    path: '/curriculums/:curriculumId/show',
    component: require('@/pages/InAppWeb/CurriculumDetail').default,
  },
  {
    path: '/curriculums/create',
    component: require('@/pages/InAppWeb/CurriculumCreation').default,
  },
  {
    path: '/curriculums/:curriculumId/edit',
    component: require('@/pages/InAppWeb/CurriculumEditing').default,
  },
  {
    path: '/students',
    component: require('@/pages/InAppWeb/Students').default,
  },
  {
    path: '/students/:studentId/sent_curriculums',
    component: require('@/pages/InAppWeb/SentCurriculums').default,
  },
  {
    path: '/students/:studentId/unsent_curriculums',
    component: require('@/pages/InAppWeb/UnsentCurriculums').default,
  },
  {
    path: '/live_lesson',
    component: require('@/pages/InAppWeb/LiveLesson').default,
  },
]

export default requireAuth(routes)
